import { apiManagerRequest } from '../../axios';
import {
  medicalProviderDirectoryInstitutionBussinessType,
  medicalProviderDirectorySpecialtiesSections,
} from '../../constants/medicalAttention';
import urls from '../../constants/urls';
import Session from '../../utils/session';

class MedicalProviderDirectoryService {
  static #getUrl(section) {
    switch (section) {
      case medicalProviderDirectorySpecialtiesSections.SPECIALTIES:
        return urls.medicalProviderDirectory.specialities;
      case medicalProviderDirectorySpecialtiesSections.URGENT_CARE:
        return urls.medicalProviderDirectory.specialitiesUrgentCare;
      default:
        throw new Error('Invalid section type');
    }
  }
  static async getSpecialitiesBySection(section) {
    console.log('section', section);
    const { codPrestador } = Session.getAuth()?.modelEspecifico;

    const url = this.#getUrl(section);
    const finalUrl = url.replace(':code', codPrestador);
    const { data } = await apiManagerRequest.get(finalUrl);

    return data.map((item) => item.Especialidad);
  }

  static async getAddresses(search) {
    const { codPrestador } = Session.getAuth()?.modelEspecifico;
    const url =
      urls.medicalProviderDirectory.addresses.replace(':code', codPrestador) + `?search=${search}`;

    const { data } = await apiManagerRequest.get(url);

    return data?.map((item, index) => ({ ...item, id: String(index) })) ?? [];
  }

  static async getPracticionersBySpecialityAndType(
    plan,
    speciality,
    { deno_prov, deno_loc, deno_part },
    sectionType,
  ) {
    const { codPrestador } = Session.getAuth()?.modelEspecifico;
    const url = urls.medicalProviderDirectory.searchPracticioners.replace(':code', codPrestador);
    const query = `?tipo=${sectionType}&pt=null&carti=${plan}&especialidad=${speciality}&deno_prov=${
      deno_prov ?? ''
    }&deno_part=${deno_part ?? ''}&deno_loc=${deno_loc ?? ''}`;

    const { data } = await apiManagerRequest.get(url + query);

    return data.response?.docs ?? [];
  }

  static async getAutocompleteProfesionals(name) {
    const { codPrestador } = Session.getAuth()?.modelEspecifico;
    const url = urls.medicalProviderDirectory.autocompletePractitioner
      .replace(':code', codPrestador)
      .replace(':name', name);

    const { data } = await apiManagerRequest.get(url);

    return data?.map((item) => item.ape_razon);
  }

  // Usado por la sección de instituciones y profesionales.
  static async getPracticionersByBussinessName(plan, profesional) {
    const { codPrestador } = Session.getAuth()?.modelEspecifico;
    const url = urls.medicalProviderDirectory.searchPracticioners.replace(':code', codPrestador);
    const query = `?tipo=${medicalProviderDirectoryInstitutionBussinessType}&pt=null&carti=${plan}&ape_razon=${profesional}`;

    const { data } = await apiManagerRequest.get(url + query);

    return data.response?.docs ?? [];
  }
}

export default MedicalProviderDirectoryService;
